import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseButtonComponent } from '../base-button';
import { CheckoutHistory } from 'src/app/models/checkout-history';
import { VisualizationHistoryItem } from 'src/app/models/visualization-history';
import { HistoryItem } from '../../../models/history-user';
import { Favorite } from 'src/app/state/user/favorites/models/favorites.response';

@Component({
  selector: 'app-remove-button',
  templateUrl: './remove-button.component.html',
  styleUrls: ['./remove-button.component.scss', '../base-button.scss'],
})
export class RemoveButtonComponent extends BaseButtonComponent {
  @Input()
  checkout: CheckoutHistory;

  @Input()
  historyItem: HistoryItem;

  @Input()
  favorite: Favorite;

  @Input()
  visualization: VisualizationHistoryItem;

  @Output()
  removed = new EventEmitter<CheckoutHistory | Favorite | VisualizationHistoryItem | HistoryItem>();

  doRemove() {
    this.doAction(() => {
      if (this.checkout) {
        this.apiService.removeCheckoutFromHistory(this.userService.getUserId(), this.checkout.checkoutId).subscribe(
          () => {
            this.removed.emit(this.checkout);
            this.toastService.showToast('messages.checkoutHistory.remove');
          },
          (_err) => {
            this.waiting = false;
            throw _err;
          }
        );
      } else if (this.favorite) {
        this.favoriteFacade.deleteFavorite(this.favorite.recordId).subscribe();
      } else if (this.visualization) {
        this.apiService
          .removeVisualizationFromHistory(
            this.userService.getUserId(),
            this.visualization.id,
            this.visualization.visualizationType
          )
          .subscribe(
            () => {
              this.removed.emit(this.visualization);
              this.toastService.showToast('messages.visualizationHistory.remove');
            },
            (_err) => {
              this.waiting = false;
              throw _err;
            }
          );
      } else if (this.historyItem) {
        this.apiService.hideHistoryItem(this.historyItem.recordId, this.historyItem.type).subscribe(
          () => {
            this.removed.emit(this.historyItem);
            this.toastService.showToast('messages.visualizationHistory.remove');
          },
          (_err) => {
            this.waiting = false;
            throw _err;
          }
        );
      }
    });
  }
}
